var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEstabelecimentoReligioso = function SvgEstabelecimentoReligioso(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFECE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5642 24.1417C39.6727 23.9927 40 23.5 40 23.5C40 23.5 40.3967 24.0866 40.4357 24.1417C40.5256 24.2673 40.6175 24.3967 40.7122 24.53C40.9096 24.8079 41.1196 25.1036 41.347 25.4154C42.9123 27.5546 45.25 30.7654 45.25 32.6103C45.25 33.9572 44.656 35.1758 43.705 36.061C42.6942 36.993 41.3711 37.5069 40 37.4999C38.6327 37.5047 37.3123 36.9983 36.295 36.0791C35.344 35.1939 34.75 33.9761 34.75 32.6292C34.75 30.7842 37.0878 27.5554 38.653 25.4154C39.0093 24.9355 39.3062 24.5295 39.5642 24.1417Z",
    fill: "#E76F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56.75C26 55.7835 26.7835 55 27.75 55H34.75V42.75C34.75 40.817 36.317 39.25 38.25 39.25H41.75C43.683 39.25 45.25 40.817 45.25 42.75V55H52.25C53.2165 55 54 55.7835 54 56.75V58.5H26V56.75Z",
    fill: "#E76F00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEstabelecimentoReligioso, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/estabelecimento-religioso.16b135b7.svg";
export { ForwardRef as ReactComponent };